import React from 'react';

export function Button({ className = '', variant = 'primary', size = 'md', children, ...props }) {
  const variants = {
    primary: 'primary',
    secondary: 'manage',
    outline: 'manage outline',
    danger: 'manage danger',
    ghost: 'manage ghost'
  };

  return (
    <button 
      className={`${variants[variant] || 'primary'} ${className}`} 
      {...props}
    >
      {children}
    </button>
  );
}

export function Input({ className = '', icon: Icon, label, error, ...props }) {
  return (
    <div className="formGroup">
      {label && <label>{label}</label>}
      <div className="inputIcon">
        {Icon && <Icon size={18} />}
        <input 
          className={className} 
          {...props} 
        />
      </div>
      {error && <small style={{ color: 'var(--red)', fontSize: '11px', marginTop: '5px', display: 'block' }}>{error}</small>}
    </div>
  );
}

export function Card({ title, subtitle, actions, children, className = '' }) {
  return (
    <div className={`panel ${className}`}>
      {(title || actions) && (
        <div className="panelHead">
          <div>
            {title && <h2>{title}</h2>}
            {subtitle && <p style={{ color: 'var(--muted)', fontSize: '12px', marginTop: '4px' }}>{subtitle}</p>}
          </div>
          {actions && <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>{actions}</div>}
        </div>
      )}
      {children}
    </div>
  );
}

export function Badge({ children, variant = 'purple', className }) {
  const colors = {
    purple: 'bg-[#8b5cf6]/15 text-[#8b5cf6]',
    green: 'bg-[#43d66f]/15 text-[#43d66f]',
    red: 'bg-[#ff4d6d]/15 text-[#ff4d6d]',
    yellow: 'bg-[#f5c542]/15 text-[#f5c542]',
    blue: 'bg-[#38bdf8]/15 text-[#38bdf8]',
  };

  return (
    <span className={`badge ${colors[variant] || colors.purple} ${className || ''}`}>
      {children}
    </span>
  );
}

export * from './SearchInput';
export * from './Skeleton';
